import { HttpEvent, HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BRAND_ID_HEADER } from '../core.constants';
import { BRAND_ID } from '../config/brand.constants';

export const brandIdInterceptor: HttpInterceptorFn = (
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> =>
  next(
    httpRequest.clone({
      setHeaders: { [BRAND_ID_HEADER]: BRAND_ID },
    })
  );
